var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnbookableRoomPoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    fill: "#0000FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1904 20.2858C37.7593 20.8551 38.0787 21.6271 38.0785 22.4319C38.0782 23.2367 37.7582 24.0084 37.1889 24.5773C36.6196 25.1462 35.8477 25.4657 35.0428 25.4654C34.238 25.4651 33.4663 25.1451 32.8974 24.5758C32.3452 24.0034 32.0398 23.2369 32.047 22.4415C32.0542 21.6461 32.3735 20.8853 32.936 20.323C33.4986 19.7606 34.2595 19.4416 35.0549 19.4347C35.8503 19.4277 36.6166 19.7334 37.1889 20.2858",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1904 20.2858C37.7593 20.8551 38.0787 21.6271 38.0785 22.4319C38.0782 23.2367 37.7582 24.0084 37.1889 24.5773C36.6196 25.1462 35.8477 25.4657 35.0428 25.4654C34.238 25.4651 33.4663 25.1451 32.8974 24.5758C32.3452 24.0034 32.0398 23.2369 32.047 22.4415C32.0542 21.6461 32.3735 20.8853 32.936 20.323C33.4986 19.7606 34.2595 19.4416 35.0549 19.4347C35.8503 19.4277 36.6166 19.7334 37.1889 20.2858",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3059 14.8678C28.1823 15.7442 28.6747 16.9329 28.6747 18.1723C28.6747 19.4117 28.1823 20.6004 27.3059 21.4768C26.4295 22.3532 25.2408 22.8456 24.0014 22.8456C22.762 22.8456 21.5733 22.3532 20.6969 21.4768C19.8205 20.6004 19.3281 19.4117 19.3281 18.1723C19.3281 17.5586 19.449 16.9509 19.6839 16.3839C19.9187 15.8169 20.2629 15.3017 20.6969 14.8678C21.1308 14.4338 21.646 14.0896 22.213 13.8548C22.78 13.6199 23.3877 13.499 24.0014 13.499C25.2408 13.499 26.4295 13.9914 27.3059 14.8678Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3059 14.8678C28.1823 15.7442 28.6747 16.9329 28.6747 18.1723C28.6747 19.4117 28.1823 20.6004 27.3059 21.4768C26.4295 22.3532 25.2408 22.8456 24.0014 22.8456C22.762 22.8456 21.5733 22.3532 20.6969 21.4768C19.8205 20.6004 19.3281 19.4117 19.3281 18.1723C19.3281 17.5586 19.449 16.9509 19.6839 16.3839C19.9187 15.8169 20.2629 15.3017 20.6969 14.8678C21.1308 14.4338 21.646 14.0896 22.213 13.8548C22.78 13.6199 23.3877 13.499 24.0014 13.499C25.2408 13.499 26.4295 13.9914 27.3059 14.8678",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1007 20.2853C15.3944 20.5642 15.6293 20.8992 15.7916 21.2703C15.9538 21.6415 16.0401 22.0414 16.0453 22.4465C16.0505 22.8515 15.9746 23.2536 15.822 23.6288C15.6694 24.004 15.4432 24.3449 15.1568 24.6314C14.8703 24.9178 14.5294 25.144 14.1542 25.2966C13.7789 25.4492 13.3769 25.5251 12.9719 25.5199C12.5668 25.5147 12.1669 25.4284 11.7957 25.2662C11.4245 25.1039 11.0896 24.869 10.8107 24.5753C10.2658 24.0015 9.9666 23.2377 9.97682 22.4465C9.98703 21.6553 10.3059 20.8994 10.8653 20.34C11.4248 19.7805 12.1807 19.4616 12.9719 19.4514C13.763 19.4412 14.5269 19.7404 15.1007 20.2853Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1007 20.2853C15.3944 20.5642 15.6293 20.8992 15.7916 21.2703C15.9538 21.6415 16.0401 22.0414 16.0453 22.4465C16.0505 22.8515 15.9746 23.2536 15.822 23.6288C15.6694 24.004 15.4432 24.3449 15.1568 24.6314C14.8703 24.9178 14.5294 25.144 14.1542 25.2966C13.7789 25.4492 13.3769 25.5251 12.9719 25.5199C12.5668 25.5147 12.1669 25.4284 11.7957 25.2662C11.4245 25.1039 11.0896 24.869 10.8107 24.5753C10.2658 24.0015 9.9666 23.2377 9.97682 22.4465C9.98703 21.6553 10.3059 20.8994 10.8653 20.34C11.4248 19.7805 12.1807 19.4616 12.9719 19.4514C13.763 19.4412 14.5269 19.7404 15.1007 20.2853",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4984 34.4995V32.8555C40.4984 31.8609 40.1033 30.9071 39.4 30.2038C38.6968 29.5006 37.7429 29.1055 36.7484 29.1055H35.5469",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4984 34.4995V32.8555C40.4984 31.8609 40.1033 30.9071 39.4 30.2038C38.6968 29.5006 37.7429 29.1055 36.7484 29.1055H35.5469",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 34.4995V32.8555C7.5 31.8609 7.89509 30.9071 8.59835 30.2038C9.30161 29.5006 10.2554 29.1055 11.25 29.1055H12.4515",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 34.4995V32.8555C7.5 31.8609 7.89509 30.9071 8.59835 30.2038C9.30161 29.5006 10.2554 29.1055 11.25 29.1055H12.4515",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0029 34.5001V32.0986C32.0029 31.4092 31.8671 30.7265 31.6032 30.0895C31.3394 29.4526 30.9527 28.8738 30.4652 28.3863C29.9777 27.8988 29.3989 27.5121 28.762 27.2483C28.125 26.9844 27.4423 26.8486 26.7529 26.8486H21.2344C19.842 26.8486 18.5066 27.4018 17.5221 28.3863C16.5375 29.3709 15.9844 30.7062 15.9844 32.0986V34.5001",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0029 34.5001V32.0986C32.0029 31.4092 31.8671 30.7265 31.6032 30.0895C31.3394 29.4526 30.9527 28.8738 30.4652 28.3863C29.9777 27.8988 29.3989 27.5121 28.762 27.2483C28.125 26.9844 27.4423 26.8486 26.7529 26.8486H21.2344C19.842 26.8486 18.5066 27.4018 17.5221 28.3863C16.5375 29.3709 15.9844 30.7062 15.9844 32.0986V34.5001",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnbookableRoomPoi);
export default __webpack_public_path__ + "static/media/unbookable-room-poi.98f1508eb9d9f9b081c63a0194bebded.svg";
export { ForwardRef as ReactComponent };